export default __webpack_public_path__ + "static/media/Icons_Edit Icon.8dd0d1d0.svg";